import { gql } from '@apollo/client'

export const SABRE_FLAVOR_FRAGMENT = gql`
  fragment Flavor on Flavor {
    id
    name
    displayFlavor
  }
`
